import {useLazyQuery, useQuery} from '@apollo/client'
import {Accordion, Breadcrumb, Button, Card, Col, Form, InputGroup, ListGroup, Row} from 'react-bootstrap'
import {GET_ALL_GROUPS} from '../../gql/queries/asiignmentGruopQuery'
import {useEffect, useState} from 'react'
import {toast} from 'react-toastify'
import {IMembersNode, IResGroups} from '../../types/assignmentGroups'
import {useDisclourse} from '../../hooks/useDisclourse'
import {ModalAddAssignmentGroup} from './components/ModalAddAssignmentGroup'
import clsx from 'clsx'
import {getColorMember, parseId} from '../../helpers'
import moment from 'moment'
import {cleanVariables, PaginationUtils} from '../shared/PaginationUtils'
import {SIZE_PAGE_DEFAULT} from '../../helpers/consts'
import {PaginationSection} from '../shared/PaginationSection'
import {useGetUser} from '../../store/userStore'
import {GET_ALL_ORGANIZATIONS} from '../../gql/queries/organizationsQuery'

export const AssignmentGroupsPage = () => {
  const [gqlGetGroups, {data, loading, error, refetch}] = useLazyQuery<IResGroups>(
    GET_ALL_GROUPS,
    {
      fetchPolicy: 'no-cache',
    }
  )

  const [dataArr, setDataArr] = useState<IResGroups['allGroupAssignments']['edges']>([])
  const {isOpen, onClose, onOpen} = useDisclourse()
  const [first, setFirst] = useState(SIZE_PAGE_DEFAULT)
  const [currentPage, setCurrentPage] = useState(1)
  const [expandedRows, setExpandedRows] = useState<Set<string>>(new Set())
  const userGroups = useGetUser((s) => s.user?.groups) || []
  const isSuperAdmin = userGroups.includes('SuperAdministrador')

  const [infoGruop, setInfoGruop] = useState<null | {
    id: string
    name: string
    members: IMembersNode[]
    supervisorIds?: (string | number)[]
    organizationId?: string | number
  }>(null)

  const [formData, setFormData] = useState({
    text: '',
    organizationId: '',
  })

  let totalElements = data?.allGroupAssignments?.totalCount ?? 0
  const totalPages = Math.ceil(totalElements / first)
  const {start, end} = PaginationUtils.getPaginationRange(currentPage, first, totalElements)

  const updatePage = (n: number) => {
    setCurrentPage(n)
  }

  const handleFilters = () => {
    const variables = cleanVariables({
      first: first,
      offset: (currentPage - 1) * first,
      nameIcontains: formData.text,
      userName: formData.text, // También buscar por nombre de usuario
      organization: isSuperAdmin && formData.organizationId ? parseId(formData.organizationId) : null,
    })

    gqlGetGroups({variables})
  }

  const toggleRow = (id: string) => {
    setExpandedRows((prev) => {
      const newSet = new Set(prev)
      if (newSet.has(id)) {
        newSet.delete(id)
      } else {
        newSet.add(id)
      }
      return newSet
    })
  }

  useEffect(() => {
    handleFilters()
  }, [gqlGetGroups, currentPage, first])

  useEffect(() => {
    if (!data) return
    const {edges} = data.allGroupAssignments
    setDataArr(edges)
  }, [data])

  useEffect(() => {
    if (error) toast.error('Error: ' + error.message)
  }, [error])

  const {
    data: dataOrganizations,
    loading: loadingOrganizations,
    error: errorOrganizations,
  } = useQuery(GET_ALL_ORGANIZATIONS, {
    variables: {first: 100},
    fetchPolicy: 'no-cache',
    skip: !isSuperAdmin,
  })

  useEffect(() => {
    if (errorOrganizations) toast.error('Error: ' + errorOrganizations.message)
  }, [errorOrganizations])

  return (
    <div className='policies-page'>
      <header className='header'>
        <Breadcrumb>
          <Breadcrumb.Item className='d-blok d-md-none'>
            <span>
              <i className='bi bi-list fs-1' />
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Assignment Groups</Breadcrumb.Item>
        </Breadcrumb>
        <div className='d-flex align-items-center gap-2'>
          <Button
            size='sm'
            onClick={() => {
              setInfoGruop(null)
              onOpen()
            }}
          >
            <i className='bi bi-plus fs-3' /> New Group
          </Button>
        </div>
      </header>
      <Row className='policies'>
        <Col md={12} lg={12} sm={12} xl={12} className='container'>
          <div className='policies-container'>
            <div className='title-header'>
              <h3>All Assignment Groups</h3>
            </div>
            <div className='filters-header'>
              <InputGroup>
                <Form.Control
                  placeholder='Search by group name, user name or email...'
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      text: e.target.value,
                    }))
                  }
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault()
                      handleFilters()
                    }
                  }}
                  value={formData.text}
                />
                {isSuperAdmin && (
                  <Form.Select
                    value={formData.organizationId}
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        organizationId: e.target.value,
                      }))
                      setCurrentPage(1)
                    }}
                    disabled={loadingOrganizations}
                  >
                    {loadingOrganizations ? (
                      <option value=''>Loading...</option>
                    ) : (
                      <option value=''>All Organizations</option>
                    )}
                    {dataOrganizations?.allOrganizations?.edges?.map(({node}: any) => (
                      <option key={node.id} value={parseId(node.id)}>
                        {node.name}
                      </option>
                    ))}
                  </Form.Select>
                )}
                <Button
                  onClick={() => handleFilters()}
                  variant='outline-success'
                  style={{border: '1px solid #dbdfe9'}}
                >
                  Search
                </Button>
              </InputGroup>
            </div>
            <div className='results-header'>
              <PaginationSection
                first={first}
                setFirst={(n) => {
                  setFirst(n)
                  setCurrentPage(1)
                }}
                currentPage={currentPage}
                totalPages={totalPages}
                start={start}
                end={end}
                totalPolicies={totalElements}
                updatePage={updatePage}
                PaginationUtils={PaginationUtils}
              />
              <div className='col-md-3'>
                <div className='results-filter'>
                  <Col lg={12} md={12} sm={12} xs={12}></Col>
                </div>
              </div>
            </div>
            <div className='list-carrier table-scrollable table-container'>
              <table className='table-scrollable table-scroll table table-striped table-hover'>
                <thead>
                  <tr role='row'>
                    <th className='fw-bold' style={{width: '40px'}}></th>
                    <th className='fw-bold'>Name</th>
                    {isSuperAdmin && <th className='fw-bold d-none d-lg-table-cell'>Organization</th>}
                    <th className='fw-bold d-none d-lg-table-cell'>Supervisors</th>
                    <th className='fw-bold d-none d-lg-table-cell text-center'>Members</th>
                    <th className='fw-bold d-none d-lg-table-cell'>Created</th>
                    <th className='fw-bold d-none d-lg-table-cell text-center'>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {dataArr.map(({node}) => (
                    <>
                      <tr key={node.id}>
                        <td className='px-2 text-center'>
                          <Button
                            variant='link'
                            size='sm'
                            onClick={() => toggleRow(node.id)}
                            className='p-0'
                          >
                            <i
                              className={`bi bi-chevron-${
                                expandedRows.has(node.id) ? 'down' : 'right'
                              } fs-5`}
                            />
                          </Button>
                        </td>
                        <td className='px-4'>{node.name}</td>
                        {isSuperAdmin && (
                          <td className='px-2'>
                            {node.organization ? (
                              <span>{node.organization.name}</span>
                            ) : (
                              <span className='text-muted'>No organization</span>
                            )}
                          </td>
                        )}
                        <td className='px-2'>
                          {node.supervisors && node.supervisors.edges.length > 0 ? (
                            <div>
                              {node.supervisors.edges.map(({node: supervisor}, idx) => (
                                <div key={supervisor.id}>
                                  <div className='fw-semibold'>
                                    {supervisor.firstName} {supervisor.lastName}
                                  </div>
                                  <small className='text-muted'>{supervisor.email}</small>
                                  {idx < node.supervisors.edges.length - 1 && <hr className='my-1' />}
                                </div>
                              ))}
                            </div>
                          ) : (
                            <span className='text-muted'>No supervisors assigned</span>
                          )}
                        </td>
                        <td className='px-2 text-center'>{node.user.edges.length}</td>
                        <td className='px-2'>{moment(node.created).format('DD MMM, YYYY')}</td>
                        <td className='px-2 text-center'>
                          <Button
                            size='sm'
                            variant='warning'
                            onClick={() => {
                              setInfoGruop({
                                id: node.id,
                                name: node.name,
                                members: node.user.edges,
                                supervisorIds: node.supervisors?.edges.map(({node: s}) => parseId(s.id)) || [],
                                organizationId: node.organization ? parseId(node.organization.id) : undefined,
                              })
                              onOpen()
                            }}
                          >
                            <i className='bi bi-pencil' /> Edit
                          </Button>
                        </td>
                      </tr>
                      {expandedRows.has(node.id) && (
                        <tr>
                          <td colSpan={7} className='bg-light'>
                            <div className='p-3'>
                              <h6 className='mb-3 fw-bold'>Members:</h6>
                              {node.user.edges.length === 0 ? (
                                <div className='text-muted'>No members assigned</div>
                              ) : (
                                <div style={{maxHeight: '300px', overflowY: 'auto'}}>
                                  <ListGroup>
                                    {node.user.edges.map(({node: nodeMember}, j) => (
                                      <ListGroup.Item key={nodeMember.id}>
                                        <div className='d-flex align-items-center'>
                                          <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
                                            <div
                                              className={clsx(
                                                'symbol-label fs-3 text-uppercase',
                                                `bg-light-${getColorMember(j)}`,
                                                `text-${getColorMember(j)}`
                                              )}
                                            >
                                              {nodeMember.firstName?.charAt(0)}
                                              {nodeMember.lastName?.charAt(0)}
                                            </div>
                                          </div>
                                          <div className='d-flex flex-column'>
                                            <span className='text-gray-800 text-hover-primary mb-1'>
                                              {nodeMember.firstName} {nodeMember.lastName} -{' '}
                                              {nodeMember.email}
                                            </span>
                                            <span className='text-muted'>{nodeMember.rol}</span>
                                          </div>
                                        </div>
                                      </ListGroup.Item>
                                    ))}
                                  </ListGroup>
                                </div>
                              )}
                            </div>
                          </td>
                        </tr>
                      )}
                    </>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Col>
      </Row>

      {isOpen && (
        <ModalAddAssignmentGroup
          isOpen={isOpen}
          onClose={onClose}
          infoGroup={infoGruop}
          refetch={refetch}
        />
      )}
    </div>
  )
}
